/**
 * Wraps the "Blackout Edition" / "Whiteout Edition" suffix on product
 * card titles in a small colored pill (dark pill for Blackout, light
 * pill for Whiteout) so those listings are easy to pick out at a
 * glance in a full grid of otherwise-plain product titles — same idea
 * as the nav's own Blackout & Whiteout pill treatment.
 *
 * Runs on any `.card__heading` anywhere Dawn renders one (collection
 * grids, related products, search results) via a MutationObserver,
 * matching the pattern already used by clvry-color-swatch-fallback.js
 * for surviving dynamically-loaded/re-rendered markup.
 */
(function () {
  var SUFFIXES = [
    { match: " — Blackout Edition", label: "Blackout Edition", tone: "black" },
    { match: " — Whiteout Edition", label: "Whiteout Edition", tone: "white" },
  ];

  function processHeading(el) {
    if (el.dataset.clvryEditionPill) return;
    var a = el.tagName === "A" ? el : el.querySelector("a");
    if (!a) return;

    var textNode = null;
    for (var i = 0; i < a.childNodes.length; i++) {
      var node = a.childNodes[i];
      if (node.nodeType === Node.TEXT_NODE && node.textContent.indexOf(" — ") !== -1) {
        textNode = node;
        break;
      }
    }
    if (!textNode) return;

    var raw = textNode.textContent;
    var suffix = null;
    for (var j = 0; j < SUFFIXES.length; j++) {
      if (raw.trim().indexOf(SUFFIXES[j].match.trim()) !== -1 && raw.trim().slice(-SUFFIXES[j].match.trim().length) === SUFFIXES[j].match.trim()) {
        suffix = SUFFIXES[j];
        break;
      }
    }
    if (!suffix) return;

    var splitAt = raw.lastIndexOf(suffix.match);
    if (splitAt === -1) return;

    var prefix = raw.slice(0, splitAt);
    var pill = document.createElement("span");
    pill.className = "clvry-edition-pill clvry-edition-pill--" + suffix.tone;
    pill.textContent = suffix.label;

    textNode.textContent = prefix;
    a.insertBefore(pill, textNode.nextSibling);
    el.dataset.clvryEditionPill = "done";
  }

  function init() {
    document.querySelectorAll(".card__heading").forEach(processHeading);
  }

  init();
  new MutationObserver(init).observe(document.body, { childList: true, subtree: true });
})();
